/**
 * Klab MMP Report API
 *
 * Contact: jesuspalominomartinez1234@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GroupedWebItem { 
    domain: string;
    totalSeconds: number;
    classification?: GroupedWebItem.ClassificationEnum;
}
export namespace GroupedWebItem {
    export const ClassificationEnum = {
        Productive: 'PRODUCTIVE',
        Unproductive: 'UNPRODUCTIVE',
        Neutral: 'NEUTRAL'
    } as const;
    export type ClassificationEnum = typeof ClassificationEnum[keyof typeof ClassificationEnum];
}


